import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-8 text-center', className)}>
      {icon && (
        <span className="h-10 w-10 text-neutral-300 mb-3 flex items-center justify-center">
          {icon}
        </span>
      )}
      {title && <p className="text-sm font-medium text-neutral-500 mb-1">{title}</p>}
      {description && <p className="text-sm text-neutral-400">{description}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}

export default EmptyState;
